import includes from 'lodash/includes';

export default {
  type: {
    type: String,
    required: true,
  },
  submitUrl: {
    type: String,
    required: true,
  },
  i18n: {
    type: Object,
    required: true,
    validator(data) {
      const requiredProps = [
        'workstationsLabel',
        'workstationsPlaceholder',
        'cityLabel',
        'cityPlaceholder',
        'cityNoResults',
        'search',
      ];

      return Object.keys(data)
        .filter(key => includes(requiredProps, key)).length === requiredProps.length;
    },
  },
};
